import React from 'react';
import '../css/info.css';
import { Container } from 'react-bootstrap';

const Topbar = () => {
  return (
    <div className="top-divs">
      <Container>
        <div className="top-bars">
          {/* Left Section */}
          <div className="top-item">
            <i className="fas fa-map-pin icon"></i>
            <a
              className="links"
              href="https://maps.app.goo.gl/Dy5d9xgvzyQA71kq5"
              target="_blank"
              rel="noopener noreferrer"
            >
              249 Middle Country Rd, Selden, NY 11784
            </a>
          </div>

          {/* Right Section */}
          <div className="top-item">
            <span className="phones">Call Now!</span>
            <a className="links" href="tel:+16317327373">
              (631) 732-7373
            </a>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Topbar;
